import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import KnowledgeBase from "@/pages/KnowledgeBase";
import ArticleView from "@/pages/ArticleView";
import ArticleEdit from "@/pages/ArticleEdit";
import Academy from "@/pages/Academy";
import Downloads from "@/pages/Downloads";
import Announcements from "@/pages/Announcements";
import Telegram from "@/pages/Telegram";
import AIAssistant from "@/pages/AIAssistant";
import Settings from "@/pages/Settings";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminKnowledge from "@/pages/admin/AdminKnowledge";
import AdminAcademy from "@/pages/admin/AdminAcademy";
import AdminDownloads from "@/pages/admin/AdminDownloads";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminTelegram from "@/pages/admin/AdminTelegram";
import AdminEscalations from "@/pages/admin/AdminEscalations";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminAIReview from "@/pages/admin/AdminAIReview";
import AcceptInvitation from "@/pages/AcceptInvitation";
import Payment from "@/pages/Payment";
import Signup from "@/pages/Signup";
import ResetPassword from "@/pages/ResetPassword";
import InvitePage from "@/pages/InvitePage";
import OperationSystem from "@/pages/OperationSystem";
import Renew from "@/pages/Renew";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-0">
        <div className="text-zinc-500 text-sm tracking-widest uppercase animate-shimmer">Loading EM Operating System</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/operationsystem" element={<OperationSystem />} />
        <Route path="/accept-invitation/:token" element={<AcceptInvitation />} />
        <Route path="/pay/:token" element={<Payment />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/renew" element={<Protected><Renew /></Protected>} />
        <Route
          path="/"
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="knowledge-base" element={<KnowledgeBase />} />
          <Route path="knowledge-base/new" element={<AdminOnly><ArticleEdit /></AdminOnly>} />
          <Route path="knowledge-base/:id" element={<ArticleView />} />
          <Route path="knowledge-base/:id/edit" element={<AdminOnly><ArticleEdit /></AdminOnly>} />
          <Route path="academy" element={<Academy />} />
          <Route path="downloads" element={<Downloads />} />
          <Route path="announcements" element={<Announcements />} />
          <Route path="telegram" element={<Telegram />} />
          <Route path="ai-assistant" element={<AIAssistant />} />
          <Route path="settings" element={<Settings />} />
          <Route path="invite" element={<InvitePage />} />
          <Route path="admin" element={<AdminOnly><AdminLayout /></AdminOnly>}>
            <Route index element={<AdminKnowledge />} />
            <Route path="knowledge" element={<AdminKnowledge />} />
            <Route path="academy" element={<AdminAcademy />} />
            <Route path="downloads" element={<AdminDownloads />} />
            <Route path="announcements" element={<AdminAnnouncements />} />
            <Route path="telegram" element={<AdminTelegram />} />
            <Route path="ai-escalations" element={<AdminEscalations />} />
            <Route path="ai-escalations/:id" element={<AdminEscalations />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="ai-review" element={<AdminAIReview />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
